// DYNAMIC HEADER
document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector(".site-header");
    const root = document.documentElement;
    const mainContent = document.querySelector("#main-content");
    const mobileMenu = document.getElementById("mobile-menu"); // ✅

    let lastScroll = 0;

    function updateHeaderSpacing() {
        if (header && mainContent) {
            const headerHeight = header.offsetHeight;
            root.style.setProperty("--header-height", headerHeight + "px");
        }
    }

    updateHeaderSpacing();
    window.addEventListener("resize", updateHeaderSpacing);

    // Scroll hide/show
    window.addEventListener("scroll", function () {
        // ✅ Stop scroll-detectie als mobile menu open is
        if (mobileMenu && mobileMenu.classList.contains('is-open')) {
            return;
        }

        let currentScroll = window.pageYOffset;
        const headerHeight = header.offsetHeight;

        if (currentScroll > headerHeight) {
            header.classList.add("scrolled");
        } else {
            header.classList.remove("scrolled");
        }

        if (currentScroll > lastScroll && currentScroll > headerHeight) {
            header.classList.add("hide");
        } else {
            header.classList.remove("hide");
        }

        lastScroll = currentScroll;
    });
});